module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "480",
      "scrollable": "",
      "content-class": "sw-nt-dialog-wrap"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  }, [_c('v-card', {
    staticClass: "sw-nt-card"
  }, [_c('v-card-title', {
    staticClass: "sw-nt-title pb-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('FieldSurveyForm.newTechnicianTitle')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "aria-label": _vm.$t('FieldSurveyForm.cancel'),
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-3",
    attrs: {
      "label": ((_vm.$t('NewUser.name')) + " *"),
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "background-color": "#FFF",
      "color": "#0098E1",
      "maxlength": "50",
      "rules": _vm.$ponceConfig.requiredRules
    },
    on: {
      "blur": _vm.parseNames
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "mb-3",
    attrs: {
      "label": ((_vm.$t('NewUser.lastName')) + " *"),
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "background-color": "#FFF",
      "color": "#0098E1",
      "maxlength": "50",
      "rules": _vm.$ponceConfig.requiredRules
    },
    on: {
      "blur": _vm.parseNames
    },
    model: {
      value: (_vm.lastName),
      callback: function($$v) {
        _vm.lastName = $$v
      },
      expression: "lastName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "mb-3",
    attrs: {
      "label": ((_vm.$t('FieldSurveyForm.newTechnicianEmail')) + " *"),
      "type": "email",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.$ponceConfig.emailRules
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sw-nt-phone"
  }, [_c('VuePhoneNumberInput', {
    attrs: {
      "color": "#0098E1",
      "size": "lg",
      "default-country-code": "AR",
      "translations": _vm.phoneInputTranslations
    },
    on: {
      "update": _vm.setPhoneNumber
    },
    model: {
      value: (_vm.phoneNumberInput),
      callback: function($$v) {
        _vm.phoneNumberInput = $$v
      },
      expression: "phoneNumberInput"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "px-4 pb-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "text-none",
    attrs: {
      "text": "",
      "color": "grey darken-1",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('FieldSurveyForm.cancel')) + "\n      ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "sw-nt-save-btn text-none",
    attrs: {
      "color": "#0098E1",
      "depressed": "",
      "loading": _vm.saving,
      "disabled": !_vm.canSubmit
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('FieldSurveyForm.newTechnicianSave')) + "\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96c4cddc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FieldSurveys/SurveyWorkNewTechnicianDialog.vue
// module id = 1737
// module chunks = 0